module.exports = __webpack_public_path__ + "static/media/jumbo5.15f83b60.png";